import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { IonicPageModule } from "ionic-angular";
import { UserPopoverPage } from "./user-popover";

@NgModule({
  declarations: [UserPopoverPage],
  imports: [
    IonicPageModule.forChild(UserPopoverPage),
    TranslateModule.forChild(),
    AngularSvgIconModule,
  ],
})
export class UserPopoverPageModule {}



// WEBPACK FOOTER //
// ./src/navigation/components/user-popover/user-popover.module.ts